module.exports = __webpack_public_path__ + "static/media/noti-dropdown.bf4e4c33.svg";